type RepairNetworkItem = { element: HTMLElement; key: string };

function initRepairNetwork(componentNode: Element) {
  if (!(componentNode instanceof HTMLElement)) return;
  if (componentNode.dataset.repairNetworkBound === "true") return;
  componentNode.dataset.repairNetworkBound = "true";

  const repairSelect = componentNode.querySelector(
    "[data-repair-network-select]"
  );
  if (!(repairSelect instanceof HTMLSelectElement)) return;

  const cardNodes = Array.from(
    componentNode.querySelectorAll("[data-repair-network-item]")
  );
  const repairCards = cardNodes
    .filter((node): node is HTMLElement => node instanceof HTMLElement)
    .map<RepairNetworkItem>((element) => ({
      element,
      key: element.dataset.key ?? "",
    }));

  const showSelectedByKey = (selectedKey: string) => {
    repairCards.forEach(({ element, key }) => {
      if (key === selectedKey) element.removeAttribute("hidden");
      else element.setAttribute("hidden", "hidden");
    });
  };

  repairSelect.addEventListener("change", () =>
    showSelectedByKey(repairSelect.value)
  );
  showSelectedByKey(repairSelect.value);
}

function mountRepairNetworksIn(rootNode: ParentNode) {
  Array.from(rootNode.querySelectorAll("[data-repair-network]")).forEach(
    initRepairNetwork
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () =>
    mountRepairNetworksIn(document)
  );
} else {
  mountRepairNetworksIn(document);
}

document.addEventListener("shopify:section:load", (event) => {
  const targetNode = event.target;
  if (targetNode instanceof HTMLElement) mountRepairNetworksIn(targetNode);
});
